import writeXlsxFile from "write-excel-file";
import { getMatch } from "../../../utils/services/match";

export async function createXlsx({
  jwt,
  idEvent,
  limit,
  countData,
  codeQrcode,
  empresa,
  cargo,
  code1,
  code2,
  code3,
  group,
  setFinishExport,
}) {
  const roomType = {
    4: "Quadruplo",
    3: "Triplo",
    2: "Duplo",
  };

  const formatDate = (date) => {
    try {
      if (!date) return "";

      const formatedDate = date.split("T")[0].split("-").reverse().join("/");
      const formatTime = date.split("T")[1].split(".")[0];

      return `${formatedDate} ${formatTime}`;
    } catch (error) {
      return date;
    }
  };

  const schema = [
    {
      column: "ID Hospede 1",
      type: String,
      value: (match) => (match.login_id_1 == null ? "" : match.login_id_1),
    },
    {
      column: "Nome Hospede 1",
      type: String,
      value: (match) =>
        match.login_nome_1 == null
          ? ""
          : match.restricao_hospedagem_1
            ? `${match.login_nome_1} (Restrição: ${match.restricao_hospedagem_1})`
            : match.login_nome_1,
    },
    {
      column: "Email Hospede 1",
      type: String,
      value: (match) =>
        match.login_email_1 == null ? "" : match.login_email_1,
    },
    {
      column: codeQrcode ? "Código QRCode Hospede 1" : null,
      type: String,
      value: (match) => (codeQrcode ? match.codeqrcode_1 : null),
    },

    {
      column: empresa ? "Empresa Hospede 1" : null,
      type: String,
      value: (match) => (empresa ? match.empresa_1 : null),
    },
    {
      column: cargo ? "Cargo Hospede 1" : null,
      type: String,
      value: (match) => (cargo ? match.cargo_1 : null),
    },

    {
      column: code1 ? "Código Interno 1 - Hospede 1" : null,
      type: String,
      value: (match) => (code1 ? match.codigo_interno_1_1 : null),
    },
    {
      column: code2 ? "Código Interno 2 - Hospede 1" : null,
      type: String,
      value: (match) => (code2 ? match.codigo_interno_2_1 : null),
    },
    {
      column: code3 ? "Código Interno 3 - Hospede 1" : null,
      type: String,
      value: (match) => (code3 ? match.codigo_interno_3_1 : null),
    },
    {
      column: "Status Hospede 1",
      type: String,
      value: (match) =>
        match.login_email_1 == null
          ? ""
          : match.login_status_1 === "completed"
            ? "Completo"
            : "Pendente",
    },
    {
      column: group ? "Grupo(s) Hospede 1" : null,
      type: String,
      value: (match) =>
        group && match.grupos_id_1 && match.grupos_id_1.length > 0
          ? match.grupos_id_1.map((group) => group.name).join(", ")
          : "",
    },
    {
      column: "ID Hospede 2",
      type: String,
      value: (match) => (match.login_id_2 == null ? "" : match.login_id_2),
    },
    {
      column: "Nome Hospede 2",
      type: String,
      value: (match) =>
        match.login_nome_2 == null
          ? ""
          : match.restricao_hospedagem_2
            ? `${match.login_nome_2} (Restrição: ${match.restricao_hospedagem_2})`
            : match.login_nome_2,
    },
    {
      column: "Email Hospede 2",
      type: String,
      value: (match) =>
        match.login_email_2 == null ? "" : match.login_email_2,
    },
    {
      column: codeQrcode ? "Código QRCode Hospede 2" : null,
      type: String,
      value: (match) => (codeQrcode ? match.codeqrcode_2 : null),
    },

    {
      column: empresa ? "Empresa Hospede 2" : null,
      type: String,
      value: (match) => (empresa ? match.empresa_2 : null),
    },
    {
      column: cargo ? "Cargo Hospede 2" : null,
      type: String,
      value: (match) => (cargo ? match.cargo_2 : null),
    },
    {
      column: code1 ? "Código Interno 1 - Hospede 2" : null,
      type: String,
      value: (match) => (code1 ? match.codigo_interno_1_2 : null),
    },
    {
      column: code2 ? "Código Interno 2 - Hospede 2" : null,
      type: String,
      value: (match) => (code2 ? match.codigo_interno_2_2 : null),
    },
    {
      column: code3 ? "Código Interno 3 - Hospede 2" : null,
      type: String,
      value: (match) => (code3 ? match.codigo_interno_3_2 : null),
    },
    {
      column: "Status Hospede 2",
      type: String,
      value: (match) =>
        match.login_email_2 == null
          ? ""
          : match.login_status_2 === "completed"
            ? "Completo"
            : "Pendente",
    },
    {
      column: group ? "Grupo(s) Hospede 2" : null,
      type: String,
      value: (match) =>
        group && match.grupos_id_2 && match.grupos_id_2.length > 0
          ? match.grupos_id_2.map((group) => group.name).join(", ")
          : "",
    },
    {
      column: "ID Hospede 3",
      type: String,
      value: (match) => (match.login_id_3 == null ? "" : match.login_id_3),
    },
    {
      column: "Nome Hospede 3",
      type: String,
      value: (match) =>
        match.login_nome_3 == null
          ? ""
          : match.restricao_hospedagem_3
            ? `${match.login_nome_3} (Restrição: ${match.restricao_hospedagem_3})`
            : match.login_nome_3,
    },
    {
      column: "Email Hospede 3",
      type: String,
      value: (match) =>
        match.login_email_3 == null ? "" : match.login_email_3,
    },
    {
      column: codeQrcode ? "Código QRCode Hospede 3" : null,
      type: String,
      value: (match) => (codeQrcode ? match.codeqrcode_3 : null),
    },

    {
      column: empresa ? "Empresa Hospede 3" : null,
      type: String,
      value: (match) => (empresa ? match.empresa_3 : null),
    },
    {
      column: cargo ? "Cargo Hospede 3" : null,
      type: String,
      value: (match) => (cargo ? match.cargo_3 : null),
    },
    {
      column: code1 ? "Código Interno 1 - Hospede 3" : null,
      type: String,
      value: (match) => (code1 ? match.codigo_interno_1_3 : null),
    },
    {
      column: code2 ? "Código Interno 2 - Hospede 3" : null,
      type: String,
      value: (match) => (code2 ? match.codigo_interno_2_3 : null),
    },
    {
      column: code3 ? "Código Interno 3 - Hospede 3" : null,
      type: String,
      value: (match) => (code3 ? match.codigo_interno_3_3 : null),
    },
    {
      column: "Status Hospede 3",
      type: String,
      value: (match) =>
        match.login_email_3 == null
          ? ""
          : match.login_status_3 === "completed"
            ? "Completo"
            : "Pendente",
    },
    {
      column: group ? "Grupo(s) Hospede 3" : null,
      type: String,
      value: (match) =>
        group && match.grupos_id_3 && match.grupos_id_3.length > 0
          ? match.grupos_id_3.map((group) => group.name).join(", ")
          : "",
    },
    {
      column: "ID Hospede 4",
      type: String,
      value: (match) => (match.login_id_4 == null ? "" : match.login_id_4),
    },
    {
      column: "Nome Hospede 4",
      type: String,
      value: (match) =>
        match.login_email_1 && match.login_nome_4
          ? match.restricao_hospedagem_4
            ? `${match.login_nome_4} (Restrição: ${match.restricao_hospedagem_4})`
            : match.login_nome_4
          : "",
    },
    {
      column: "Email Hospede 4",
      type: String,
      value: (match) =>
        match.login_email_4 == null ? "" : match.login_email_4,
    },
    {
      column: codeQrcode ? "Código QRCode Hospede 4" : null,
      type: String,
      value: (match) => (codeQrcode ? match.codeqrcode_4 : null),
    },

    {
      column: empresa ? "Empresa Hospede 4" : null,
      type: String,
      value: (match) => (empresa ? match.empresa_4 : null),
    },
    {
      column: cargo ? "Cargo Hospede 4" : null,
      type: String,
      value: (match) => (cargo ? match.cargo_4 : null),
    },
    {
      column: code1 ? "Código Interno 1 - Hospede 4" : null,
      type: String,
      value: (match) => (code1 ? match.codigo_interno_1_4 : null),
    },
    {
      column: code2 ? "Código Interno 2 - Hospede 4" : null,
      type: String,
      value: (match) => (code2 ? match.codigo_interno_2_4 : null),
    },
    {
      column: code3 ? "Código Interno 3 - Hospede 4" : null,
      type: String,
      value: (match) => (code3 ? match.codigo_interno_3_4 : null),
    },
    {
      column: "Status Hospede 4",
      type: String,
      value: (match) =>
        match.login_email_4 == null
          ? ""
          : match.login_status_4 === "completed"
            ? "Completo"
            : "Pendente",
    },
    {
      column: group ? "Grupo(s) Hospede 4" : null,
      type: String,
      value: (match) =>
        group && match.grupos_id_4 && match.grupos_id_4.length > 0
          ? match.grupos_id_4.map((group) => group.name).join(", ")
          : "",
    },
    {
      column: "Tipo Quarto",
      type: String,
      value: (match) => roomType[match.room_size],
    },
    {
      column: "Data e Hora da Criação",
      type: String,
      value: (match) => formatDate(match.createdAt),
    },
  ];
  const numberOfRequisitions = Math.ceil(countData / limit);

  let allRequests = [];
  for (let i = 1; i <= numberOfRequisitions; i++) {
    const request = await getMatch({
      eventId: idEvent,
      jwt: jwt,
      offset: i,
      limit: limit,
      search: "",
    });
    allRequests.push(...request.data);

    setTimeout(() => {}, 500);
    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0,
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }
  await writeXlsxFile(allRequests, {
    schema: schema.filter((e) => e.column != null),
    fileName: "RelatorioQuartos.xlsx",
  });
}
